import React, { Fragment } from "react";

import "./AttributeItems.css";
import NoContent from "../NoContent/NoContent";
import { required, length } from "../../util/validators";
import Input from "../../components/Form/Input/Input";
import Button from "../../components/Button/Button";
import MessageHandler from "../../components/MessageHandler/MessageHandler";

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required],
  },
};

class AttributeItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      postForm: POST_FORM,
      formIsValid: false,
      editAttributeItem: false,
      attributeItems: [], //
      noAttributeItems: true,
      showMessage: false,
      isEditing: false,
      attributeItemCode: 0,
      DeleteAttributeItemCode: 0,
    };
  }

  componentDidMount() {
    if (this.props.attributeItems.length !== 0) {
      this.setState({
        attributeItems: this.props.attributeItems,
        noAttributeItems: this.props.attributeItems.length === 0 ? true : false,
      });
    }
  }

  componentDidUpdate(previousProps, previousState) {
    if (previousProps.attributeItems !== this.props.attributeItems) {
      let updatedForm = POST_FORM;
      updatedForm["title"].value = "";
      updatedForm["title"].valid = false;
      updatedForm["title"].touched = false;
      updatedForm["title"].errorMessage = "";

      this.setState({
        postForm: updatedForm,
        formIsValid: false,
        attributeItems: this.props.attributeItems,
        noAttributeItems: this.props.attributeItems.length === 0 ? true : false,
        editAttributeItem: false,
      });
    }
  }

  postInputChangeHandler = (id, value) => {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";

      for (const validator of prevState.postForm["title"].validators) {
        isValid = isValid && validator(value).hasError;
        errorMessage =
          !isValid && errorMessage === "" ? validator(value).errorMessage : errorMessage;
      }

      const updatedForm = {
        ...prevState.postForm,
        ["title"]: {
          ...prevState.postForm["title"],
          valid: isValid,
          errorMessage: errorMessage,
          value:  value,
        },
      };

      let formIsValid = updatedForm["title"].valid;

      return {
        postForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };

  inputBlurHandler = () => {
    this.setState((prevState) => {
      return {
        postForm: {
          ...prevState.postForm,
          ["title"]: {
            ...prevState.postForm["title"],
            touched: true,
          },
        },
      };
    });
  };

  acceptPostChangeHandler = () => {
    if (this.state.formIsValid) {
      const post = {
        code: this.state.attributeItemCode,
        attributeCode: this.props.selectedAttributeCode,
        title: this.state.postForm.title.value,
      };
      if (this.state.isEditing) {
        this.onFinishInlineItemHandler(post);
      } else {
        this.onFinishInlineItemHandler(post);
      }
      this.setState({
        postForm: POST_FORM,
        formIsValid: false,
        isEditing: false,
      });
    } else {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.postForm };
        let isValid = true;
        let errorMessage = "";
        for (const validator of prevState.postForm["title"].validators) {
            isValid =
                isValid && validator(prevState.postForm["title"].value).hasError;
            errorMessage =
                !isValid && errorMessage === ""
                ? validator(prevState.postForm["title"].value).errorMessage
                : errorMessage;
        }
        updatedForm = {
            ...updatedForm,
            ["title"]: {
                ...updatedForm["title"],
                valid: isValid,
                errorMessage: errorMessage,
            },
        };     

        return {
          postForm: updatedForm,
        };
      });
    }
  };

  newAttributeHandler = () => {
    this.setState({
      noAttributeItems: false,
      postForm: POST_FORM,
      formIsValid: false,
      isEditing: false,
    });
  };

  onEditHandler = (data) => {
    const Index = this.state.attributeItems.findIndex((p) => p.code === data.code);
    this.setState(() => {
      const updatedForm = {
        title: {
          value: this.state.attributeItems[Index].title,
          valid: true,
          touched: true,
          errorMessage: "",
          validators: [required, length({ min: 2 })],
        },
      };
      return {
        postForm: updatedForm,
        formIsValid: true,
        attributeItemCode: data.code,
        isEditing: true,
        editAttributeItem: true,
      };
    });
  };

  onDeleteAttributeHandler = () => {
    this.onDeleteItemHandler({
      code: this.state.DeleteAttributeItemCode,
    });
    this.setState({
      DeleteAttributeItemCode: 0,
      showMessage: false,
    });
  };

  onDeleteHandler = (data) => {
    const Index = this.state.attributeItems.findIndex((p) => p.code === data.code);

    this.setState({
      DeleteAttributeItemCode: data.code,
      showMessage: true,
    });
  };

  onCancelAttributeHandler = () => {
    this.setState({
      attributeCode: 0,
      showMessage: false,
    });
  };
  //////////////////////////////////////////////////////////////////////
  onFinishInlineItemHandler = (postData) => {
    let graphqlQuery = {
      query: `
        mutation createNewAttributeItem($attributeCode: Int!, $title: String!) {
              createAttributeItem(attributeItemInput: {attributeCode: $attributeCode, title: $title}) {
                code
                title
                isActive
              }
          }
        `,
      variables: {
        title: postData.title,
        attributeCode: this.props.selectedAttributeCode,
      },
    };
    if (this.state.editAttributeItem) {
      graphqlQuery = {
        query: `
          mutation updateNewAttributeItem($code: Int!, $attributeCode: Int!, $title: String!) {
              updateAttributeItem(code: $code, attributeItemInput: {attributeCode: $attributeCode, title: $title}) {
              code
              title
              isActive
              }
          }
          `,
        variables: {
          code: postData.code,
          title: postData.title,
          attributeCode: this.props.selectedAttributeCode,
        },
      };
    }
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let post;
        if (!this.state.editAttributeItem) {
          post = {
            code: resData.data.createAttributeItem.code,
            title: resData.data.createAttributeItem.title,
            isActive: resData.data.createAttributeItem.isActive,
            };
        }else {
          post = {
            code: resData.data.updateAttributeItem.code,
            title: resData.data.updateAttributeItem.title,
            isActive: resData.data.updateAttributeItem.isActive,
          };
        }

        this.setState((prevState) => {
          let updatedPosts = [...prevState.attributeItems];

          if (this.state.editAttributeItem) {
            const postIndex = prevState.attributeItems.findIndex(
              (p) => p.code === post.code
            );
            updatedPosts[postIndex] = post;
          } else {
            updatedPosts.push(post);
          }

          let updatedForm = POST_FORM;
          updatedForm["title"].value = "";
          updatedForm["title"].valid = false;
          updatedForm["title"].touched = false;
          updatedForm["title"].errorMessage = "";

          return {
            attributeItems: updatedPosts,
            postForm: updatedForm,
            formIsValid: false,
            attributeItemCode: 0,
            isEditing: false,
            editAttributeItem: false,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        // this.setState({ functionButtonsLoading: true });
      });
  };
  ///////////////////////////////////////////////////////////////////////
  onDeleteItemHandler = (data) => {
    const graphqlQuery = {
      query: `
        mutation {
          deleteAttributeItem(attributeItemCode: ${parseInt(data.code)})
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("خطا در حذف آیتم ویژگی!");
        }
        this.setState((prevState) => {
          let updatedPosts = [...prevState.attributeItems];

          const postIndex = prevState.attributeItems.findIndex(
            (p) => p.code === data.code
          );
          if (postIndex > -1) {
            updatedPosts.splice(postIndex, 1);
          }
          return {
            attributeItems: updatedPosts,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        // this.setState({ functionButtonsLoading: true });
      });
  };

  render() {
    return (
      <Fragment>
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelAttributeHandler}
          message={"آیا می‌خواهید آیتم ویژگی را پاک کنید؟"}
          onCancelModal={this.onCancelAttributeHandler}
          onAcceptModal={this.onDeleteAttributeHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        {this.state.noAttributeItems && (
          <NoContent
            firstInfoStatement="شما تا به حال هیچ آیتم ویژگی‌ تعریف نکرده‌اید"
            secondInfoStatement="برای تعیین و مقداردهی آیتم‌های کالایی میبایست ابتدا ویژگی‌های کالایی را تعریف کنید."
            image="https://seller.digikala.com/static/files/ac21f0e6.svg"
            onClickHandler={this.newAttributeHandler}
            button="افزودن ویژگی‌های کالایی"
          />
        )}
        {!this.state.noAttributeItems &&
          (this.state.attributeItems.length !== 0 ? (
            <div className="mn-attribute-group-select__section-fields  mn-attribute-profile__add-doc">
              <ul>
                {this.state.attributeItems.map((data, index) => {
                  return (
                    <li key={index} className="mn-attribute-group-li">
                      <div className="mn-attribute-group-select__item mn-attribute-group-select__link">
                        {data.title}
                      </div>
                      <span className="mn-attribute-group__spacer"></span>
                      <span className="mn-attribute-group-select__item_icon">
                        <i
                          className="fa fa-pencil-square-o mn-attribute-group-select__item-edit"
                          aria-hidden="true"
                          onClick={this.onEditHandler.bind(this, {
                            code: data.code,
                          })}
                        ></i>
                        <i
                          className="fa fa-trash-o mn-attribute-group-select__item-delete"
                          aria-hidden="true"
                          onClick={this.onDeleteHandler.bind(this, {
                            code: data.code,
                          })}
                        ></i>
                      </span>
                    </li>
                  );
                })}
              </ul>
              <form onSubmit={e => { e.preventDefault(); }}>
                <div className="search-form__autocomplete-container">
                  <div className="search-form__autocomplete">
                    <Input
                      id="item-title"
                      label=""
                      type="text"
                      control="input"
                      required="required"
                      onChange={this.postInputChangeHandler.bind(this)}
                      onBlur={this.inputBlurHandler}
                      valid={this.state.postForm["title"].valid}
                      touched={this.state.postForm["title"].touched}
                      value={this.state.postForm["title"].value || ""}
                      validationError={
                        !this.state.valid &&
                        this.state.postForm["title"].errorMessage
                      }
                    />
                  </div>
                  <div className="c-content-accordion__step-controls c-content-accordion__step-controls--category">
                    <Button
                      design="greenish"
                      mode=""
                      type="button"
                      loading={false}
                      onClick={this.acceptPostChangeHandler}
                    >
                      {this.state.isEditing ? "ویرایش آیتم" : "ثبت آیتم"}
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          ) : (
            <form onSubmit={e => { e.preventDefault(); }}>
              <div className="mn-attribute-group__inputs mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                <Input
                  id="item-title"
                  label=""
                  type="text"
                  control="input"
                  required="required"
                  onChange={this.postInputChangeHandler.bind(this)}
                  onBlur={this.inputBlurHandler}
                  valid={this.state.postForm["title"].valid}
                  touched={this.state.postForm["title"].touched}
                  value={this.state.postForm["title"].value || ""}
                  validationError={
                    !this.state.valid &&
                    this.state.postForm["title"].errorMessage
                  }
                />
              </div>
              <Button
                design="next"
                mode=""
                type="button"
                loading={false}
                onClick={this.acceptPostChangeHandler}
              >
                {this.state.isEditing ? "ویرایش آیتم" : "ثبت آیتم"}
              </Button>
            </form>
          ))}
      </Fragment>
    );
  }
}

export default AttributeItems;











// <div className="search-form__autocomplete-container">
//     <div className="search-form__autocomplete">        
//         <input id="searchKeywordInput" className="uk-input js-prevent-submit" type="text" placeholder="نام محصول یا DKP">
//     </div>
//     <div className="c-content-accordion__step-controls c-content-accordion__step-controls--category">
//         <button id="searchButton" className="search-form__btn search-form__btn--search" type="button" disabled="">
//             جستجو
//         </button>
//     </div>
// </div>